<template>
  <div class="text-center">
    <v-btn
      id="show-row-tiles-button"
      v-show="!sheet"
      color="primary"
      class="ma-2"
      @click="sheet = true"
      icon
      title="Show Bottom Panel"
    >
      <v-icon x-large> mdi-arrow-up-bold-box-outline </v-icon>
    </v-btn>
    <v-bottom-sheet v-model="sheet" persistent hide-overlay no-click-animation>
      <v-sheet class="sidebar-overlay">
        <v-tabs
          v-if="sheet && !hideTabs"
          v-model="tab"
          class="pl-4 bottom-tile-viewer-tabs"
        >
          <div
            class="pa-2"
            style="margin-left: -8px; background-color: transparent"
          >
            <v-btn
              id="hide-row-tiles-button"
              color="primary"
              @click="sheet = !sheet"
              icon
              title="Hide Bottom Panel"
            >
              <v-icon x-large> mdi-arrow-down-bold-box-outline </v-icon>
            </v-btn>
          </div>
          <v-tab id="tiles-tab" style="background-color: transparent"
            >Tiles</v-tab
          >
          <v-tab
            id="timeline-tab"
            v-if="unique_acquisitions"
            style="background-color: transparent"
            >Timeline</v-tab
          >
        </v-tabs>
        <v-tabs-items v-model="tab" style="background-color: transparent">
          <v-tab-item>
            <cell-tiles-viewer
              :cell_feature="cell_feature"
              :topRowStyle="
                !hideTabs
                  ? {
                      'margin-top': '-40px !important',
                      'z-index': 1,
                      position: 'fixed',
                      width: '100%',
                      'pointer-events': 'none',
                    }
                  : {}
              "
            >
              <template v-if="hideTabs" v-slot:topLeft>
                <v-btn
                  id="hide-row-tiles-button"
                  color="primary"
                  icon
                  @click="sheet = !sheet"
                  title="Hide Bottom Panel"
                >
                  <v-icon x-large>mdi-arrow-down-bold-box-outline</v-icon>
                </v-btn>
              </template>
            </cell-tiles-viewer>
          </v-tab-item>
          <v-tab-item v-if="unique_acquisitions">
            <acquisitions-timeline
              :unique_acquisitions="unique_acquisitions"
              @change="(acq_id) => this.$emit('change', acq_id)"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import CellTilesViewer from "./CellTilesViewer.vue";
import AcquisitionsTimeline from "./AcquisitionsTimeline.vue";
import { mapGetters } from "vuex";

export default {
  props: ["cell_feature", "unique_acquisitions", "hideTabs"],
  components: { CellTilesViewer, AcquisitionsTimeline },
  computed: {
    ...mapGetters(["user_details"]),
  },
  watch: {
    cell_feature: {
      handler(newVal) {
        if (newVal) {
          this.sheet = true;
        }
      },
      immediate: true,
    },
    tab(newVal) {
      this.$emit("tabSelected", newVal);
    },
  },
  data() {
    return {
      sheet: false,
      tab: 0,
    };
  },
};
</script>
<style lang="scss">
.bottom-tile-viewer-tabs,
.bottom-tile-viewer-tabs.theme--dark.v-tabs > .v-tabs-bar {
  background-color: rgba(30, 30, 30, 0.1);
}
</style>
<style lang="scss" scoped>
.sidebar-overlay {
  background-color: transparent;
  background-color: rgba(0, 0, 0, 0.7);
}
</style>
